<template>
  <div>
    <div>
    <br/>
      <p>
        The new computation technologies, such as big data analytics, modern machine learning technology, artificial
        intelligence (AI), blockchain, and security processing, have the great potential to be embedded into network to
        enable it to be intelligent and trustworthy. On the other hand, Information-Centric Networking (ICN),
        software-defined network (SDN), network function virtualization (NFV), network slicing, and data center network
        have emerged as the novel networking paradigms for fast and efficient delivering and retrieving data. Against
        this backdrop, there is a strong trend to move the computations from the cloud to not only the edges but also
        the resource-sufficient networking nodes, which triggers the convergence between the emerging networking
        concepts and the new computation technologies.
      </p>
      <p>
        The ultimate goals for networking researches include intelligence, trust, and efficiency, which can be enhanced
        by or benefit for the intelligent computations. There are many open challenges for the emerging network concepts
        to meet the intelligent computations: what computations should be embedded; which node should be enforced with
        the computation; how can the computations, such as big data analytics, security, AI, machine learning,
        blockchain, be seamlessly embedded into the network and enable it to be efficient, trustworthy and accountable;
        how to fast locate the required and suitable computation nodes; how to efficiently transfer data through series
        of computation nodes; how to efficiently collect and process the big networking data; how to design networking
        architectures and protocols to easily support the efficient and diverse computations; how to achieve ultra-low
        latency communications with distributed computations; and how to migrate from the Internet to the
        computation-enabled network.
      </p>
      <p>
        The NMIC workshop 2022 solicits the papers that address the technical challenges and applications of the
        distributed computations for networking, the intelligent computations supported by the novel networking
        technologies, and the enforcement of series of computations. We envision that the combination of computations
        with networking will provide more effective computation support for applications and enable the network to be
        more intelligent, trustworthy, and efficient. The areas of interests include, but are not limited to, the
        following:
      </p>
      <ul>
        <li>Intelligent Computation for Networking</li>
        <ul>
          <li>Networking architecture and protocols for integrating caching, computation, and communications</li>
          <li>Machine learning, data mining and big data analytics in networking</li>
          <li>Collection and processing for big network data</li>
          <li>Security, privacy, trust, accountability for/with intelligent computation networking</li>
          <li>Integrating Blockchain with networking</li>
          <li>In-network data computations for network measurement and management</li>
        </ul>
        <li>Networking and Distributed Computing for Intelligent Applications</li>
        <ul>
          <li>In-network computation for future networks, inter-data center networking and 5G</li>
          <li>Cooperative task scheduling and resource management for edge computing</li>
          <li>Distributed machine learning on edges</li>
          <li>Information-centric networking with/for computations</li>
          <li>Intelligent Internet edge integrating edge, fog, and mobile edge computing with networking</li>
          <li>Intelligent service function/computation chaining</li>
          <li>Distributed computations for network anomaly detection and security</li>
          <li>Network function virtualization, software-defined network, and network slicing for distributed
            computations
          </li>
          <li>Networking computations for big data, streaming, IoT, and AR/VR</li>
          <li>Distributed artificial intelligence with/for networking</li>
          <li>Big data networking in healthcare, V2V, smart cities, industry and other applications</li>
        </ul>
        <li>Networked Intelligent Applications</li>
        <ul>
          <li>Blockchain-driven Intelligent Applications</li>
          <li>Cloud/Edge/Fog based Intelligent Applications</li>
          <li>Metaverse based Intelligent Applications</li>
          <li>Emerging Networked Intelligent Applications</li>
          <li>User Experience in Networked Intelligent Applications</li>
          <li>Data Modelling for Networked Intelligent Applications</li>
        </ul>
      </ul>
    </div>
    <div>
      <h3>
        Submission Guidelines:
      </h3>
      <p>
        All submissions should follow the <a
          href="http://www.ieee.org/conferences_events/conferences/publishing/templates.html">IEEE 8.5″ x 11″ Two-Column
        Format</a>. Each submission can have up to 6 pages. Authors of accepted papers are expected to present their
        papers at the workshop. The selected papers will be recommended to SCI journal SPECIAL ISSUE such as Sensors and
        Elsevier Journal of Systems Architecture. We will plan it in the future. All the papers are submitted via
        <a href="https://easychair.org/conferences/?conf=msn2022">EasyChair</a> and select "NMIC2022" on the step of "Select a Track".
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "CallForPapers"
}
</script>

<style scoped>

</style>